import { Parameters } from '@app/models/Parameters';
import { post, get } from './http.api';
import { LabServiceRequest } from '@app/models/LabServiceConfig/LabServiceConfigRequest.api';
import { DepartmentRequest } from '@app/models/departments/DepartmentRequest';
import { DepartmentApiData } from '@app/models/departments/DepartmentResponse';
import {
  LabServiceTableData,
  LabServiceTableRow,
  LabServiceResponse,
  LabService,
  LabServiceApiData,
} from '@app/models/LabServiceConfig/LabServiceConfigResponse.api';

export const getLabServiceTableData = async (parameters: Parameters): Promise<LabServiceTableData> => {
  try {
    const { data, status } = await get<any>('lab_services', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const Services: LabServiceTableRow[] =
      data.data?.map((ServiceData: any) => ({
        id: ServiceData.id,
        code: ServiceData.code,
        name: ServiceData.name,
        department_id: ServiceData.lab_service_category?.department?.name ?? '',
        type: ServiceData.type,
      })) ?? [];

    return {
      data: Services,
      filters: {
        departments: data.filters?.departments ?? [],
        statuses: data.filters?.statuses ?? [],
        types: data.filters?.types ?? [],
      },
      pagination: {
        current: data.current_page ?? 1,
        pageSize: data.per_page ?? 10,
        total: data.total ?? Services.length,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Lab Services:', error);
    throw error;
  }
};

export const getAllLabServicees = async (): Promise<LabServiceResponse> => {
  try {
    const { data, status } = await get<LabServiceResponse>(`lab_services`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLabServiceById = async (id: number): Promise<LabServiceResponse> => {
  try {
    const { data, status } = await get<LabServiceResponse>(`lab_services/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeLabService = async (DepartmentData: LabServiceRequest) => {
  try {
    const response = await post<any>('lab_services/create', DepartmentData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createLabService = async (): Promise<LabService> => {
  try {
    const { data, status } = await get<LabService>(`lab_services/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showLabService = async (id: number) => {
  try {
    const { data, status } = await get<LabServiceApiData>(`lab_services/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editLabService = async (id: number) => {
  try {
    const { data, status } = await get<any>(`lab_services/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateLabService = async (id: number, Updatecategory: any) => {
  try {
    const { data, status } = await post<any>(`lab_services/${id}/update`, Updatecategory, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
